import { combineReducers } from "@reduxjs/toolkit";
import userinfoReducer from "./features/userinfo/userinfoSlice";
import plaidReducer from "./features/userinfo/plaidSlice";
import apexReducer from "./features/userinfo/apexSlice";
import investorsSlice from "./features/investors/investorsSlice";
import canvasReducer from "./features/canvas/canvasSlice";
import { apexFeesReducer } from "./features/fees/apexFeesSlice";
import aggregatedInvestorDataReducer from "./features/aggregatedInvestorData/aggregatedInvestorDataSlice";
import planningReducer from "./features/planning/planningSlice";

const rootReducer = combineReducers({
  userinfo: userinfoReducer, // add userinfo reducer
  plaid: plaidReducer,
  apex: apexReducer,
  customers: investorsSlice,
  investors: investorsSlice,
  canvas: canvasReducer,
  planning: planningReducer, // new planning state for guided & sandbox modes
  apexFees: apexFeesReducer,
  aggregatedInvestorData: aggregatedInvestorDataReducer,
  // add other reducer
});

export default rootReducer;
